import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { WebStorage } from '../../components/auth/storage/web.storage';

@Pipe({
  name: 'momentDate'
})
export class MomentDatePipe implements PipeTransform {
  private timeZone: string = 'UTC';
  private readonly format: string = 'MMM DD, YYYY';

  constructor(private storage: WebStorage) {
    const userData = this.storage.getUserData();
    this.setTimeZone(userData?.schoolObj?.timeZone || 'UTC');
  }

  transform(value: Date | string | moment.Moment): string {
    if (!value) return '';

    let dateStr: string;
    if (moment.isMoment(value)) {
      dateStr = value.toISOString();
    } else if (value instanceof Date) {
      dateStr = value.toISOString();
    } else {
      dateStr = value; // assume it's already a string
    }

    const isDateOnly = dateStr.endsWith('T00:00:00Z') || !dateStr.includes('T');

    if (isDateOnly) {
      return moment.utc(dateStr).format(this.format);
    }

    let date = moment.utc(dateStr);
    if (this.timeZone) {
      date = date.tz(this.timeZone);
    }

    return date.format(this.format);
  }

  setTimeZone(timeZone: string): void {
    if (timeZone && moment.tz.zone(timeZone)) {
      this.timeZone = timeZone;
    } else {
      this.timeZone = 'UTC';
    }
  }
}
